/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_User_Status_InactiveInputs */

const en_enum_user_status_inactive = /** @type {(inputs: Enum_User_Status_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

const de_enum_user_status_inactive = /** @type {(inputs: Enum_User_Status_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Enum_User_Status_InactiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_user_status_inactive = /** @type {((inputs?: Enum_User_Status_InactiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_User_Status_InactiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_user_status_inactive(inputs)
	return de_enum_user_status_inactive(inputs)
});